import React, { useContext, useEffect } from 'react';
import './AuthOneLayoutWrap.css';
import hometown from '../../assets/images/hometown.png';
import raven from '../../assets/images/raven-logo-green.png';
import paymable from '../../assets/images/paymable.png';
import LegacySwitch from './LegacySwitch';
import { getCookie } from '../../utils/helper/Helper';
import { useNavigate } from 'react-router-dom';
import { ALL_ROUTES } from '../../routes/dashboard/overview/AllPathNames';
import ActionContext from '../../context/ActionContext';
import { authBankboxIcon } from './BankBoxIcon';
interface MyComponentProps {
	children?: React.ReactNode;
	className?: string;
}

const AuthTwoLayoutWrap: React.FC<MyComponentProps> = ({
	children,
	className,
}) => {
	const navigate = useNavigate();
	const actionCtx = useContext(ActionContext);
	async function authCheckpoint() {
		const auth = getCookie('token');

		const matches = location.href.includes('/login');

		if (auth && auth.length > 5 && matches) {
			navigate(ALL_ROUTES?.OVERVIEW);
		}
	}

	const ravenIcon = (
		<svg
			width="149"
			height="34"
			viewBox="0 0 149 34"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M43.3294 12.3872C43.3461 12.4087 43.3789 12.4753 43.4315 12.5178C45.9349 14.5592 46.3973 17.4743 44.553 20.132C42.9921 22.3808 40.8144 23.5707 38.0445 23.542C36.1517 23.5224 34.2591 23.4636 32.369 23.3802C31.6694 23.3496 31.0983 23.4858 30.5328 23.9413C29.4829 24.7882 28.2428 25.2658 26.7551 25.5632C26.8696 25.1898 26.9323 24.907 27.0418 24.6437C28.0769 22.1548 29.1218 19.6698 30.1578 17.18C30.2997 16.8392 30.4055 16.4838 30.5284 16.1352C30.4602 16.0932 30.3912 16.0502 30.3231 16.0081C30.1628 16.1942 29.9729 16.3622 29.8467 16.5684C29.0772 17.8226 28.3382 19.0941 27.5571 20.3407C27.0557 21.141 26.53 21.9297 25.9642 22.6863C23.7845 25.6008 20.8189 27.1434 17.2473 27.6009C16.8308 27.6539 16.4143 27.7069 15.9964 27.7471C15.8976 27.7562 15.794 27.7132 15.5318 27.6638C17.4553 24.7494 19.4165 21.9527 21.3356 19.1285C23.232 16.3373 25.1318 13.549 27.0308 10.7597C26.9568 10.6992 26.8828 10.6388 26.8079 10.5792C26.5687 10.847 26.3161 11.1044 26.093 11.3854C24.3258 13.6065 22.5783 15.8428 20.7969 18.0526C18.7045 20.6476 16.4948 23.1354 13.9068 25.2595C11.4944 27.2391 8.85784 28.7882 5.77078 29.4627C3.97122 29.8562 1.44151 29.815 0.00878252 29.3597C0.0721537 28.8908 0.485257 28.6982 0.782266 28.4503C2.47921 27.0379 4.20439 25.6592 5.90396 24.2506C12.6844 18.6339 19.2162 12.7484 25.1893 6.26624C26.3051 5.0555 27.4005 3.82321 28.4539 2.55873C28.9079 2.01428 29.4245 1.80812 30.0996 1.83444C33.5996 1.97501 37.101 2.0983 40.6007 2.25072C41.2602 2.27933 41.9332 2.34754 42.5678 2.51682C46.3832 3.53635 47.6187 7.4646 45.0876 10.5151C44.5542 11.1586 43.9432 11.7369 43.3285 12.3863L43.3294 12.3872ZM32.3173 20.2615C32.5729 20.3507 32.7001 20.4318 32.8286 20.4355C34.3298 20.4686 35.8314 20.5182 37.332 20.5058C38.3857 20.4972 39.1866 19.9406 39.7998 19.1216C40.3599 18.3731 40.6221 17.5159 40.6321 16.5768C40.6462 15.2018 39.8104 14.051 38.465 13.9256C36.8386 13.7739 35.1942 13.8079 33.4117 13.7576C33.0414 15.9598 32.6799 18.1056 32.3164 20.2605L32.3173 20.2615ZM33.9754 10.6808C35.6367 10.7277 37.2095 10.9033 38.758 10.7782C40.2672 10.6566 41.4003 8.89637 41.263 7.2618C41.1451 5.84849 40.2392 5.14442 38.4405 5.08735C37.5311 5.05899 36.6205 5.04154 35.711 5.04692C34.9712 5.05162 34.8729 5.14096 34.7432 5.86054C34.5573 6.89227 34.3849 7.92712 34.2172 8.9621C34.1299 9.5023 34.0635 10.0458 33.9754 10.6808Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M64.799 8.03958L62.3037 22.8006L57.6223 22.6687L58.0909 19.8264C56.7584 21.8682 55.0665 22.8739 53.0443 22.817C50.2466 22.7381 46.7288 20.6709 47.6643 15.0144C48.603 9.24676 52.9507 7.42939 55.8323 7.51058C57.5218 7.55819 58.8327 8.25999 59.8212 9.59113L60.1176 7.90859L64.799 8.04049L64.799 8.03958ZM58.6893 16.2945L59.2854 12.8456C58.6146 11.0802 57.6973 10.167 56.5618 10.135C55.5922 10.1076 54.7205 10.5546 53.9177 11.5015C53.143 12.4218 52.6094 13.6544 52.3723 15.1726C52.1384 16.5796 52.1887 17.7731 52.5487 18.7536C52.9369 19.7349 53.5606 20.224 54.4747 20.2498C55.8872 20.2896 57.2832 18.9709 58.6893 16.2936L58.6893 16.2945Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M81.4334 13.8865L79.8377 23.2947L75.1564 23.1628L76.7201 13.9197C76.8717 12.4547 76.9499 10.683 75.3989 10.6393C74.0137 10.6003 72.617 11.9745 71.2359 14.7355L69.838 23.0129L65.1567 22.881L67.652 8.11997L72.3333 8.25188L71.8663 11.0386C73.2263 9.02581 74.9447 8.0482 77.0216 8.10672C80.2622 8.19803 81.9708 10.5472 81.4325 13.8865L81.4334 13.8865Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M93.3324 14.6377L97.5925 23.795L92.3015 23.6459L89.8689 17.506L88.1645 18.9546L87.3987 23.5068L82.6901 23.3741L86.2468 2.40659L90.9281 2.5385L88.831 14.9823L96.0435 8.91997L99.8108 9.02612L93.3324 14.6377Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M115.589 18.6747C115.294 20.2743 114.509 21.5828 113.232 22.6285C111.955 23.6733 110.416 24.1571 108.672 24.1079L99.6976 23.855L103.053 4.15592L111.169 4.3846C114.909 4.48998 116.9 6.6255 116.368 9.71506C116.069 11.4805 115.061 12.8384 113.316 13.7596C115.066 14.6124 115.957 16.4397 115.589 18.6747ZM112.57 18.5896C113.127 15.5555 110.96 14.7466 109.768 14.713L104.283 14.5585L102.989 22.1183L108.501 22.2736C109.665 22.3064 112.097 21.5705 112.57 18.5906L112.57 18.5896ZM104.585 12.7375L109.682 12.8811C110.817 12.9131 112.911 12.3902 113.377 9.63079C113.845 6.81669 111.948 6.23609 110.757 6.20253L105.716 6.06048L104.586 12.7375L104.585 12.7375Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M119.169 22.4898C117.963 20.9866 117.572 19.146 117.939 16.9383C118.305 14.7589 119.326 12.9572 121.002 11.5361C122.706 10.1148 124.637 9.44871 126.798 9.50959C128.958 9.57047 130.628 10.338 131.805 11.8404C133.01 13.3437 133.401 15.1842 133.035 17.3637C132.668 19.5714 131.647 21.3721 129.971 22.7942C128.296 24.2162 126.364 24.8823 124.203 24.8214C122.042 24.7605 120.373 23.993 119.168 22.4898L119.169 22.4898ZM128.041 21.4365C129.127 20.2751 129.803 18.9079 130.099 17.2809C130.366 15.6806 130.155 14.2884 129.441 13.1045C128.754 11.8931 127.773 11.2836 126.499 11.2477C125.225 11.2118 124.045 11.7604 122.959 12.9218C121.873 14.0559 121.197 15.4222 120.902 17.0218C120.635 18.6495 120.845 20.0417 121.532 21.2531C122.247 22.4379 123.228 23.0474 124.502 23.0833C125.776 23.1192 126.956 22.5706 128.041 21.4365Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M138.734 17.7459L134.656 10.0074L138.202 10.1073L141.099 15.5389L146.18 10.3321L148.397 10.3946L141.892 16.9475L146.068 25.1603L142.55 25.0612L139.556 19.1827L134.186 24.8255L131.997 24.7638L138.738 17.746L138.734 17.7459Z"
				fill="var(--primary-base-color)"
			/>
		</svg>
	);

	useEffect(() => {
		authCheckpoint();
	}, []);

	useEffect(() => {
		if (
			localStorage?.getItem('theme-color') === null ||
			localStorage?.getItem('theme-color') === '' ||
			localStorage?.getItem('theme-color') === undefined
		) {
			const color = '#014345';
			actionCtx?.setThemeColor(color);
		} else {
			const color =
				localStorage?.getItem('theme-color') || 'var(--primary-base-color)';
			actionCtx?.setThemeColor(color);
		}
	}, []);

	return (
		<div className={`auth-layout-wrap ${className}`}>
			{/* left wrap start */}

			<div className={`left-wrap left-wrap-two`}>
				<div className="inner-child-wrap">
					{' '}
					{/* logo wrap start */}
					<div className="logo-wrap-box">
						{' '}
						<figure className="img-box">{ravenIcon}</figure>
					</div>
					{/* logo wrap end */}
					{/* title wrap start */}
					<div className="title-wrap-box">
						<p className="title">
							BankBox: The pocket <br />
							friendly payment Terminal
						</p>
					</div>
					{/* title wrap end */}

					{/* image wrap content box start */}
					<div className="image-wrap-content-box">
						<div className="center-wrap grey-bg">
							<figure className="img-box">{authBankboxIcon}</figure>
						</div>
					</div>
					{/* image wrap content box end */}
				</div>
			</div>
			{/* left wrap end */}
			{/* right wrap start */}
			<div className="right-wrap right-wrap-login">
				<div className="wrap">{children}</div>
			</div>
			{/* right wrap end */}
		</div>
	);
};

export default AuthTwoLayoutWrap;
